import ArrowRight from "../LogoSVG/ArrowRight";

function ProjectsDesktopItem({
  hoveredIndex,
  setHoveredIndex,
  thumbnail,
  title,
  description,
  url,
  index,
  listTech,
  highLight,
  isred,
}: any) {
  return (
    <a
      className={`pb-16  pr-20 ${
        hoveredIndex == undefined || hoveredIndex == index ? "" : "opacity-55"
      }`}
      onMouseEnter={() => setHoveredIndex(index)}
      onMouseLeave={() => setHoveredIndex(undefined)}
      href={url}
    >
      <div className="w-[280px] h-[180px] overflow-hidden rounded-md mb-4">
        <img
          src={thumbnail}
          alt="thumbnail"
          className="object-cover w-full h-full"
        />
      </div>
      <div className={`flex flex-row `}>
        <p
          className={`leading-5 font-medium mr-4 tracking-wide ${
            highLight && "text-custom-green"
          }`}
        >
          {title}
        </p>
        
      </div>
      <p className="w-[290px] text-gray-4 mt-2 mb-1">
        {description}
      </p>

      {/* <ul className="flex flex-wrap text-xs font-normal w-[340px] mb-2 text-custom-green-2">
        {listTech.map((tech: string, index: any) => (
          <li key={index} className="mr-1.5 mt-3">
            <div className="flex items-center rounded-full bg-teal-400/10 px-3 py-1 leading-5">
              {tech}
            </div>
          </li>
        ))}
      </ul> */}
    </a>
  );
}

export default ProjectsDesktopItem;
